import { render, staticRenderFns } from "./AppPanel.vue?vue&type=template&id=43d499d4&scoped=true&"
import script from "./AppPanel.vue?vue&type=script&lang=js&"
export * from "./AppPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppPanel.vue?vue&type=style&index=0&id=43d499d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d499d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43d499d4')) {
      api.createRecord('43d499d4', component.options)
    } else {
      api.reload('43d499d4', component.options)
    }
    module.hot.accept("./AppPanel.vue?vue&type=template&id=43d499d4&scoped=true&", function () {
      api.rerender('43d499d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/components/AppPanel.vue"
export default component.exports